import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import _ from 'lodash';
import { clearPlantItemRenewalForm } from 'plantItemNew/redux/slices/formSlice';
import { generatePlantItemRenewalFormattedApplication } from 'plantItemRenewal/utils/PlantItemRenewalFormatHelper';
import { PLANT_ITEM_RENEWAL_API_BASE_URL } from 'plantItemRenewal/constants/plantItemRenewalConstants';
import { getApplication } from 'shared/redux/applicationSlice';

const initialState = {
  status: undefined,
  errored: false,
  paymentRedirectUrl: undefined,
  paymentReference: undefined,
  paymentDuplicate: undefined,
};

const plantItemRenewalPaymentSlice = createSlice({
  name: 'plantItemRenewalPayment',
  initialState,
  reducers: {
    storePaymentDetails(state, action) {
      state.paymentReference = action.payload.paymentReference;
      state.paymentRedirectUrl = action.payload.paymentRedirectUrl;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initPlantItemRenewalPayment.pending, (state, _) => {
        state.status = LoadingStates.Loading;
        state.paymentReference = undefined;
        state.paymentDuplicate = undefined;
      })
      .addCase(initPlantItemRenewalPayment.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.errored = action.payload && action.payload.response && action.payload.response.data;
        state.paymentReference = undefined;
        state.paymentDuplicate = undefined;
      })
      .addCase(initPlantItemRenewalPayment.fulfilled, (state, action) => {
        state.status = LoadingStates.Succeeded;
        state.paymentReference = action.payload.paymentReference;
        state.paymentRedirectUrl = action.payload.paymentRedirectUrl;
        state.paymentDuplicate = action.payload.duplicate;
      })
      .addCase(clearPlantItemRenewalForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantItemRenewalPayment };
      });
  },
});

export const initPlantItemRenewalPayment = createAsyncThunk(
  'plantItemRenewalPayment/initPayment',
  async (arg, { getState }) => {
    let copiedState = _.cloneDeep(getState());

    const formattedApplication = generateFormattedApplication(copiedState);

    const renewalState = selectRenewalState(copiedState);

    renewalState.formattedApplication = formattedApplication;

    const resp = await axios.post(`${PLANT_ITEM_RENEWAL_API_BASE_URL}/initpayment`, renewalState, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return resp.data;
  },
);

const selectRenewalState = (state) => {
  return {
    application: state.application,
    plantItemRenewalApplicantDetails: state.plantItemRenewalApplicantDetails,
    renewalItems: state.renewalItems,
    form: state.form,
    plantItemRenewalDeclaration: state.plantItemRenewalDeclaration,
  };
};

const generateFormattedApplication = (state) => {
  try {
    let formattedApplication = generatePlantItemRenewalFormattedApplication(state);
    const selectedItems = state.renewalItems.items.filter((x) => x.isSelected);
    formattedApplication.itemCount = selectedItems.length;
    return formattedApplication;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const { storePaymentDetails } = plantItemRenewalPaymentSlice.actions;
export const plantItemRenewalPaymentReducer = plantItemRenewalPaymentSlice.reducer;
